const schema = localStorage.getItem("schema");
export const basicFormData = () => ({
  inputData: {
    category_id: "",
    uom_id: "",
    name: "",
    code: "",
    group_id: "",
    oem_id: "",
    descriptions: "",
    created_by: "",
    updated_by: "",
    is_active: true,
  },
});

export const createPageData = () => {
  const schema = localStorage.getItem("schema");

  const payload = {
    modelName: "material_masters",
    schema: schema,
    include: [
      {
        model: "category_masters",
        as: "category",
      },
      {
        model: "uom_masters",
        as: "uom",
      },
      {
        model: "oem_master",
        as: "oem",
      },
      {
        model: "group_master",
        as: "group",
      },
    ],
  };

  const navigatePage = { back: "/item-list" };

  const headerName = "Item";

  const validationType = "ItemCreate";
  const createEndpoint = "/updaterelationaldata  ";
  const updateEndpoint = "/updaterelationaldata  ";
  const getEndpoint = "/getRecords";
  const dependentDropdownData = [
    {
      module_name: "material_masters",
      initialPayload: {
        modelName: "material_masters",
        schema: schema,
        whereCondition: { is_child: false },
      },
      isOtherDependentOnThis: false,
      patchFieldName: "name",
      dropdownDataValue: "parent_id",
      endPoint: "/getRecords",
    },
  ];
  return {
    payload,
    navigatePage,
    headerName,
    validationType,
    createEndpoint,
    updateEndpoint,
    getEndpoint,
    dependentDropdownData,
  };
};

export const listPageData = () => {
  const schema = localStorage.getItem("schema");

  const payload = {
    modelName: "material_masters",
    schema: schema,
    include: [
      {
        model: "category_masters",
        as: "category",
      },
      {
        model: "uom_masters",
        as: "uom",
      },
      {
        model: "oem_master",
        as: "oem",
      },
      {
        model: "group_master",
        as: "group",
      },
    ],
    // relations: [
    //   {
    //     module: "user_masters",
    //     moduleAs: "createdBy",
    //   },
    //   {
    //     module: "user_masters",
    //     moduleAs: "updatedBy",
    //   },
    //   {
    //     module: "user_masters",
    //     moduleAs: "updatedBy",
    //   },
    // ],
  };

  const columnData = [
    { label: "Sr.no", value: "index" },
    { label: "Item Name", value: "name" },
    { label: "Item Code", value: "code" },
    { label: "Category Type", value: "category_type" },
    { label: "Category Name", value: "category.name" },
    { label: "UOM Name", value: "uom.name" },
    { label: "OEM Name", value: "oem.name" },
    { label: "Group Name", value: "group.name" },
    { label: "Status", value: "is_active" },
    { label: "Action", value: "actions" },
  ];

  const navigatePage = {
    create: "/item-create",
    edit: "/item-create",
    view: "/item-view",
  };

  const searchfields = [
    "name",
    "category.name",
    "uom.name",
    // "unit_cost",
    "code",
    "descriptions",
  ];

  const headerName = "Item";
  const endpoint = "/getRecords";
  const exportFileName = "MaterialData.xlsx";

  return {
    payload,
    navigatePage,
    headerName,
    columnData,
    endpoint,
    searchfields,
    exportFileName,
  };
};

export const exportPageData = {
  modelName: "material_masters",
  schema: schema,
  include: [
    { module: "category_masters", moduleAs: "category" },
    { module: "uom_masters", moduleAs: "uom" },
  ],
  pagination: { page: 1, pageSize: 10000 },
};
